<script lang="ts">
    import { Word } from "../../dictionary/Word";
    import {replace} from 'svelte-spa-router'
    import Icon from "../../materialize/components/Icon.svelte";
    import ProgressBar from "../../materialize/components/ProgressBar.svelte";
    import Column from "../../materialize/grid/Column.svelte";
    import Row from "../../materialize/grid/Row.svelte";
    import ListenAgainScreen from "../subcomponents/recording/ListenAgainScreen.svelte";
    import RecordScreen from "../subcomponents/recording/RecordScreen.svelte";
    import Submit from "../subcomponents/recording/Submit.svelte";
    import { fade } from "svelte/transition";
    import Spinner from "../../utils/Spinner.svelte";
    import { auth_token, current_dialect } from "../../stores/stores";
    import LoadingScreen from "../subcomponents/LoadingScreen.svelte";
    import {
        fetch_or_go_offline,
        promise_or_go_offline,
    } from "../../utils/fetch_or_go_offline";
    import { get_host } from "../../settings";
    import { get_cookie } from "../../utils/cookie_manager";
    import Authentication from "../subcomponents/Authentication.svelte";
    import Button from "../../materialize/components/Button.svelte";
    import { onMount } from "svelte";
    import FloatingActionButton from "../../materialize/components/FloatingActionButton.svelte";
import { WebAudioApiWavRecorder } from "../../utils/WebAudioApiWavRecorder";

    export let params = {
        pk_word: null,
    };
    //params.pk_word

    let current_step: number = 0;
    let total_steps: number = 2;

    let current_word: Word = null;

    let current_audio_data = {
        blob: null,
        base64: "",
    };

    function recording_finished(event) {
        current_audio_data = event.detail;
        current_step = 1;
    }

    function reset() {
        if (current_step === 2) {
            get_new_random_word();
        }

        current_step = 0;
        current_audio_data = {
            blob: null,
            base64: "",
        };
    }

    function submit_audio() {
        //FETCH POST
        let form_data = new FormData();
        form_data.set("word", current_word.id.toString());
        form_data.set("audio", current_audio_data.blob);

        const my_headers = new Headers();
        my_headers.append("Authorization", `Token ${$auth_token}`);
        my_headers.append("X-CSRFToken", get_cookie("csrftoken"));

        submit_promise = fetch(
            get_host() + `/api/dictionary/word/${params.pk_word}/audio`,
            {
                method: "POST",
                headers: my_headers,
                body: form_data,
                credentials: "same-origin",
            }
        ).then((res) => {
            if (res.ok) {
                return res;
            } else {
                throw new Error("Error adding audio");
            }
        });

        current_step = 2;

        setTimeout(reset, 3000);
    }
    let submit_promise = null;
    $: word_promise = get_word_data(params.pk_word);

    function get_word_data(pk_word)
    {
        let route_to_fetch = `/api/dictionary/word/${pk_word}`;
        return Promise.all([
            fetch_or_go_offline(route_to_fetch)
                .then((r) => {
                    if (r.ok) {
                        return r;
                    } else {
                        throw new Error("Error fetching word");
                    }
                })
                .then((res) => {
                    return res.json();
                })
                .then((res) => {
                    current_word = new Word(res);
                }),
        ]);
    }

    function get_new_random_word() {
        replace("/contribute/audio/random");
    }

    // onMount(() => {
    //     get_new_random_word();
    // });

    let test_nodes;
    let visualization_data = [];
</script>

<h4>Contributi pronuncia</h4>
<Authentication />
{#if $auth_token}
    {#await word_promise}
        <LoadingScreen />
    {:then d}
        <div transition:fade>
            <Row>
                <Column small={4} medium={2}>
                    Passo {current_step + 1} su {total_steps + 1}
                </Column>
                <Column small={8} medium={10}>
                    <ProgressBar target_steps={current_step} {total_steps} />
                </Column>
            </Row>

            <Row>
                <Column small={12}>
                    <h1 class="center-align">
                        {current_word ? current_word.word : ""}
                    </h1>
                </Column>
                <Column small={10} />
            </Row>
        </div>

        {#if current_step == 0}
            <div transition:fade>
                <RecordScreen on:completed={recording_finished} />
                <FloatingActionButton
                    on:click={get_new_random_word}
                    icon="loop"
                />
            </div>
        {:else if current_step == 1}
            <div transition:fade>
                <ListenAgainScreen
                    on:confirm={submit_audio}
                    on:cancel={reset}
                    audio_path={current_audio_data.base64}
                />
            </div>
        {:else if current_step == 2}
            {#await submit_promise}
                <div class="center-align"><Spinner /></div>
            {:then data}
                <div transition:fade>
                    <div class="center-align">
                        <Icon
                            class_list={[
                                "approu-primary-text",
                                "text-darken-1",
                                "large",
                            ]}
                            icon="done"
                        />
                    </div>
                    <h1 class="center-align">Audio inviato correttamente</h1>
                </div>
            {:catch}
                <div transition:fade>
                    <h1 class="center-align">Errore nell'invio dell'audio</h1>
                    <div class="center-align">
                        <Icon
                            class_list={["approu-error-text", "large"]}
                            icon="error_outline"
                        />
                    </div>
                    <p class="center-align">
                        Verifica la connessione e ritenta
                    </p>
                </div>
            {/await}
        {/if}
    {/await}
{:else}{/if}
